// 主网之前
// export const tinABI = [
//     {
//         "inputs": [],
//         "stateMutability": "nonpayable",
//         "type": "constructor"
//     },
//     {
//         "inputs": [],
//         "name": "AIRPORT_TOKEN_RATE",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "AIRPORT_TRX_RATE",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "BACK_RATE",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "DEPOSIT_GAP_TIME",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "EXPIRED_TIME",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "INTERVAL_TIMES",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "name": "_totalADepositAmount",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "name": "_totalDepositAmount",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "name": "_totalWithdrawAmount",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "airToken",
//         "outputs": [
//             {
//                 "internalType": "contract IERC20",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "ref",
//                 "type": "address"
//             }
//         ],
//         "name": "checkRefValid",
//         "outputs": [
//             {
//                 "internalType": "bool",
//                 "name": "",
//                 "type": "bool"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "contractBalance",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "ref",
//                 "type": "address"
//             }
//         ],
//         "name": "deposit",
//         "outputs": [],
//         "stateMutability": "payable",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "expiredRate",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "feeAddress1",
//         "outputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "feeAddress2",
//         "outputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "feeRate1",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "feeRate2",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "user",
//                 "type": "address"
//             }
//         ],
//         "name": "getWithDrawDeposit",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "amount",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "time",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "bool",
//                 "name": "withdrawed",
//                 "type": "bool"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "backAmount",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "user",
//                 "type": "address"
//             }
//         ],
//         "name": "getWithdrawIndex",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "user",
//                 "type": "address"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "index",
//                 "type": "uint256"
//             }
//         ],
//         "name": "getWithdrawInfo",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "amount",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "time",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "bool",
//                 "name": "withdrawed",
//                 "type": "bool"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "backAmount",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "user",
//                 "type": "address"
//             }
//         ],
//         "name": "getWithdrawInfos",
//         "outputs": [
//             {
//                 "components": [
//                     {
//                         "internalType": "uint256",
//                         "name": "time",
//                         "type": "uint256"
//                     },
//                     {
//                         "internalType": "uint256",
//                         "name": "amount",
//                         "type": "uint256"
//                     },
//                     {
//                         "internalType": "bool",
//                         "name": "withdrawed",
//                         "type": "bool"
//                     },
//                     {
//                         "internalType": "uint256",
//                         "name": "backAmount",
//                         "type": "uint256"
//                     }
//                 ],
//                 "internalType": "struct TokenBank.Deposit[]",
//                 "name": "",
//                 "type": "tuple[]"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "leftTime",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "loveReturnRate",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "maxAmount",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "minAmount",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "myBalance",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "refFeeRate1",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "refFeeRate2",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "name": "refs",
//         "outputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "tokenAddr",
//                 "type": "address"
//             }
//         ],
//         "name": "setAirToken",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "rate1",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "rate2",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setAirportRate",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "_depositGapTime",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_intervalTime",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_backRate",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_expireTime",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_expiredRate",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_loveReturnRate",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_refFeeRate1",
//                 "type": "uint256"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_refFeeRate2",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setAll",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "rate",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setLoveReturn",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "_maxAmount",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setMaxAmount",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "_minAmount",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setMinAmount",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "_feeAddress",
//                 "type": "address"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "fee",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setProjectAddressAndFee1",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "_feeAddress",
//                 "type": "address"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "fee",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setProjectAddressAndFee2",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "_user",
//                 "type": "address"
//             },
//             {
//                 "internalType": "uint256",
//                 "name": "_amount",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setUserDeposit",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "rate",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setWithdrawRate",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "rate",
//                 "type": "uint256"
//             }
//         ],
//         "name": "setexpiredRate",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "user",
//                 "type": "address"
//             }
//         ],
//         "name": "totalDeposit",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "user",
//                 "type": "address"
//             }
//         ],
//         "name": "totalDepositAmount",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "newOwner",
//                 "type": "address"
//             }
//         ],
//         "name": "transferOwner",
//         "outputs": [],
//         "stateMutability": "nonpayable",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "userCount",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [
//             {
//                 "internalType": "address",
//                 "name": "",
//                 "type": "address"
//             }
//         ],
//         "name": "userDeposits",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "withdrawIndex",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "inputs": [],
//         "name": "withdrawRate",
//         "outputs": [
//             {
//                 "internalType": "uint256",
//                 "name": "",
//                 "type": "uint256"
//             }
//         ],
//         "stateMutability": "view",
//         "type": "function"
//     },
//     {
//         "stateMutability": "payable",
//         "type": "receive"
//     }
// ]

//测试网 8.16

export const tinABI =[{"stateMutability":"Nonpayable","type":"Constructor"},{"outputs":[{"type":"uint256"}],"name":"AIRPORT_TOKEN_RATE","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"AIRPORT_TRX_RATE","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"BACK_RATE","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"DEPOSIT_GAP_TIME","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"EXPIRED_TIME","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"INTERVAL_TIMES","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"inputs":[{"type":"address"}],"name":"_totalADepositAmount","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"inputs":[{"type":"address"}],"name":"_totalDepositAmount","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"inputs":[{"type":"address"}],"name":"_totalWithdrawAmount","stateMutability":"view","type":"function"},{"outputs":[{"type":"address"}],"name":"airToken","stateMutability":"view","type":"function"},{"outputs":[{"type":"bool"}],"inputs":[{"name":"ref","type":"address"}],"name":"checkRefValid","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"contractBalance","stateMutability":"view","type":"function"},{"inputs":[{"name":"ref","type":"address"}],"name":"deposit","stateMutability":"Payable","type":"Function"},{"outputs":[{"type":"uint256"}],"name":"expiredRate","stateMutability":"view","type":"function"},{"outputs":[{"type":"address"}],"name":"feeAddress1","stateMutability":"view","type":"function"},{"outputs":[{"type":"address"}],"name":"feeAddress2","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"feeRate1","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"feeRate2","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256[]"}],"inputs":[{"name":"user","type":"address"}],"name":"getDepositAmounts","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256[]"}],"inputs":[{"name":"user","type":"address"}],"name":"getDepositDate","stateMutability":"view","type":"function"},{"outputs":[{"name":"amount","type":"uint256"},{"name":"time","type":"uint256"},{"name":"withdrawed","type":"bool"},{"name":"backAmount","type":"uint256"}],"inputs":[{"name":"user","type":"address"}],"name":"getWithDrawDeposit","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256[]"}],"inputs":[{"name":"user","type":"address"}],"name":"getWithdrawBackAmounts","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256[]"}],"inputs":[{"name":"user","type":"address"}],"name":"getWithdrawDate","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"inputs":[{"name":"user","type":"address"}],"name":"getWithdrawIndex","stateMutability":"view","type":"function"},{"outputs":[{"name":"amount","type":"uint256"},{"name":"time","type":"uint256"},{"name":"withdrawed","type":"bool"},{"name":"backAmount","type":"uint256"}],"inputs":[{"name":"user","type":"address"},{"name":"index","type":"uint256"}],"name":"getWithdrawInfo","stateMutability":"view","type":"function"},{"outputs":[{"type":"tuple[]"}],"inputs":[{"name":"user","type":"address"}],"name":"getWithdrawInfos","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"leftTime","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"loveReturnRate","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"maxAmount","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"minAmount","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"myBalance","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"refFeeRate1","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"refFeeRate2","stateMutability":"view","type":"function"},{"outputs":[{"type":"address"}],"inputs":[{"type":"address"}],"name":"refs","stateMutability":"view","type":"function"},{"inputs":[{"name":"tokenAddr","type":"address"}],"name":"setAirToken","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"rate1","type":"uint256"},{"name":"rate2","type":"uint256"}],"name":"setAirportRate","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"_depositGapTime","type":"uint256"},{"name":"_intervalTime","type":"uint256"},{"name":"_backRate","type":"uint256"},{"name":"_expireTime","type":"uint256"},{"name":"_expiredRate","type":"uint256"},{"name":"_loveReturnRate","type":"uint256"},{"name":"_refFeeRate1","type":"uint256"},{"name":"_refFeeRate2","type":"uint256"}],"name":"setAll","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"rate","type":"uint256"}],"name":"setLoveReturn","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"_maxAmount","type":"uint256"}],"name":"setMaxAmount","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"_minAmount","type":"uint256"}],"name":"setMinAmount","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"_feeAddress","type":"address"},{"name":"fee","type":"uint256"}],"name":"setProjectAddressAndFee1","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"_feeAddress","type":"address"},{"name":"fee","type":"uint256"}],"name":"setProjectAddressAndFee2","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"_user","type":"address"},{"name":"_amount","type":"uint256"}],"name":"setUserDeposit","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"rate","type":"uint256"}],"name":"setWithdrawRate","stateMutability":"Nonpayable","type":"Function"},{"inputs":[{"name":"rate","type":"uint256"}],"name":"setexpiredRate","stateMutability":"Nonpayable","type":"Function"},{"outputs":[{"type":"uint256"}],"inputs":[{"name":"user","type":"address"}],"name":"totalDeposit","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"inputs":[{"name":"user","type":"address"}],"name":"totalDepositAmount","stateMutability":"view","type":"function"},{"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwner","stateMutability":"Nonpayable","type":"Function"},{"outputs":[{"type":"uint256"}],"name":"userCount","stateMutability":"view","type":"function"},{"outputs":[{"name":"withdrawIndex","type":"uint256"}],"inputs":[{"type":"address"}],"name":"userDeposits","stateMutability":"view","type":"function"},{"outputs":[{"type":"uint256"}],"name":"withdrawRate","stateMutability":"view","type":"function"},{"stateMutability":"Payable","type":"Receive"}]
